import { useEffect, useState, Component } from 'react';
import '../../scss/backoffice.scss';
import { Sidemenu } from './Sidemenu';
import { Topbar } from './Topbar';
import { Footer } from './Footers';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Switch from 'react-switch';
import { FileUploader } from 'react-drag-drop-files';
import moment from 'moment-timezone';
import parse from 'html-react-parser';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import {
  getBackendAnnouncementList,
  CreateAnnouncement,
  EditAnnouncement,
  DelAnnouncement,
} from '../../services/ApiGetAnnouncementList';
import {
  AnnouncementItem,
  AnnouncementsData,
  AnnouncementInputForm,
} from '../../model/datatype';
import { Badge } from '../../components/backend/Badge';
import ReactPaginate from 'react-paginate';
import Moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Alert, Form, InputGroup, Tab, Tabs } from 'react-bootstrap';

const fileTypes = ['jpg', 'png', 'jpeg'];
export const Annoucement = (props: any) => {
  const [key, setKey] = useState('home');
  const [templateError, setTemplateError] = useState('');
  const [search, setSearch] = useState('');
  const [pageLoder, setPageLoder] = useState(false);
  const [loder, setLoader] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [formModalShow, setFormModalShow] = useState(false);
  const [formCreateModalShow, setFormCreateModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [filter, setFilter] = useState({ perpage: 10, offset: 0, subject: '' });
  const [offset, setOffset] = useState(0);

  const [editorInput, setEditorInput] = useState({
    editorTh: '',
    editorEn: '',
  });
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 1,
    totalCount: 0,
  });
  const [annoucementLists, setAnnoucementLists] = useState<
    [AnnouncementsData] | null
  >(null);
  const [annoucementItem, setAnnoucementItem] =
    useState<AnnouncementInputForm | null>(null);
  const [announcementInputForm, setAnnouncementInputForm] =
    useState<AnnouncementInputForm | null>(null);
  const [newAnnouncementInputForm, setNewAnnouncementInputForm] =
    useState<AnnouncementInputForm | null>(null);
  const [alertData, setAlertData] = useState({
    alertTitle: '',
    alertMessage: '',
    alertStatus: false,
  });
  const handleSwitch = () => {
    console.log('handleSwitch checked=', checked);
    setChecked(!checked);
    setAnnouncementInputForm((oldValues: any) => ({
      ...oldValues,
      ['status']: !checked ? 1 : 0,
    }));
  };

  const handleChange = (file: any) => {
    console.log(file);
    if (file) {
      setTemplateError('');
    }

    setFile(file);
    setAnnouncementInputForm((oldValues: any) => ({
      ...oldValues,
      ['File']: file,
    }));
  };
  const handleEditSwitch = () => {
    setChecked(!checked);
    console.log('EditSwitch checked=', checked);
    setAnnoucementItem((oldValues: any) => ({
      ...oldValues,
      ['status']: !checked ? 1 : 0,
    }));
  };
  const handleEditChange = (file: any) => {
    setFile(file);
    setAnnoucementItem((oldValues: any) => ({ ...oldValues, ['File']: file }));
  };
  const setInputValue = (e: any) => {
    const { name, value } = e.target;
    console.log('name=', name);
    if (name !== 'subject') {
      setFilter((oldValues: any) => ({ ...oldValues, ['offset']: 0 }));
      setFilter((oldValues: any) => ({ ...oldValues, [name]: value }));
      setAnnoucementLists(null);
      setOffset(0);
    } else {
      setSearch(value);
    }
  };
  const setCreateInputValue = (e: any) => {
    const { name, value } = e.target;

    setAnnouncementInputForm((oldValues: any) => ({
      ...oldValues,
      [name]: value,
    }));
  };

  const setCreateThEditorValue = (value: string) => {
    setEditorInput((oldValues: any) => ({
      ...oldValues,
      ['editorTh']: value,
    }));
    setAnnouncementInputForm((oldValues: any) => ({
      ...oldValues,
      ['detailsTh']: value,
    }));
    setAnnoucementItem((oldValues: any) => ({
      ...oldValues,
      ['detailsTh']: value,
    }));
  };

  const setCreateEnEditorValue = (value: string) => {
    setEditorInput((oldValues: any) => ({
      ...oldValues,
      ['editorEn']: value,
    }));
    setAnnouncementInputForm((oldValues: any) => ({
      ...oldValues,
      ['detailsEn']: value,
    }));
    setAnnoucementItem((oldValues: any) => ({
      ...oldValues,
      ['detailsEn']: value,
    }));
  };

  const setEditInputValue = (e: any) => {
    const { name, value } = e.target;
    setAnnoucementItem((oldValues: any) => ({ ...oldValues, [name]: value }));
  };
  const selectAnnoucement = (item: any) => {
    setAnnoucementItem(item);
    setModalShow(true);
  };
  const selectEditAnnoucement = (item: any) => {
    console.log('item=', item);
    setEditorInput((oldValues: any) => ({
      ...oldValues,
      ['editorTh']: item.detailsTh ?? '',
    }));
    setEditorInput((oldValues: any) => ({
      ...oldValues,
      ['editorEn']: item.detailsEn ?? '',
    }));
    setAnnoucementItem(item);
    setAnnoucementItem((oldValues: any) => ({
      ...oldValues,
      ['publishedDateTime']: convertDateServerToTimeZome(
        item?.publishedDateTime,
      ),
    }));
    setChecked(item.status === 1 ? true : false);
    setFormModalShow(true);
  };
  const onCreateAnnounce = () => {
    if (file === null) {
      setTemplateError('error');
      console.log('templateError=', templateError);
      return false;
    }
    setPageLoder(true);

    CreateAnnouncement(announcementInputForm).then((response: any) => {
      const getData: any = response;
      setAnnoucementLists(null);
      setLoader(false);
      setPageLoder(false);
      setAnnouncementInputForm(newAnnouncementInputForm);
      setFormCreateModalShow(false);
      toast.success('Annoucement Create Item successfully', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
  };
  const onCancelCreacteAnnounce = () => {
    setAnnouncementInputForm(newAnnouncementInputForm);
    setFormCreateModalShow(false);
  };

  const convertDateServerToTimeZome = (date: string) => {
    if (date !== '') {
      console.log('date=', date);
      console.log(
        moment(date + 'Z')
          .tz('Asia/Bangkok')
          .format('yyyy-MM-DDTHH:mm'),
      );
      return moment(date + 'Z')
        .tz('Asia/Bangkok')
        .format('yyyy-MM-DDTHH:mm');
    } else {
      return '';
    }
  };
  const onEditAnnounce = () => {
    setPageLoder(true);
    console.log('annoucementItem = ', annoucementItem);

    EditAnnouncement(annoucementItem).then((response: any) => {
      const getData: any = response;
      console.log(getData);
      if (getData.status === 200) {
        setAnnoucementLists(null);
        setFormModalShow(false);
        setLoader(false);
        setPageLoder(false);
        setAnnouncementInputForm(newAnnouncementInputForm);
        setFormCreateModalShow(false);
        toast.success('Annoucement Update successfully', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(getData.detail, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  };
  const selectDeleteAnnoucement = (item: any) => {
    setAnnoucementItem(item);
    setDeleteModalShow(true);
  };
  const onDelete = () => {
    setPageLoder(true);
    DelAnnouncement(annoucementItem).then((response: any) => {
      const getData: any = response;
      setAnnoucementLists(null);
      setLoader(false);
      setPageLoder(false);
      setAnnouncementInputForm(newAnnouncementInputForm);
      setFormCreateModalShow(false);
      toast.success('Annoucement Delete Item successfully', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
    setDeleteModalShow(false);
  };

  const onEnterSearch = (e: any) => {
    const { name, value } = e.target;

    if (name === 'subject' && e.key === 'Enter') {
      setAnnoucementLists(null);
      setFilter((oldValues: any) => ({ ...oldValues, ['subject']: value }));
    }
  };

  const onClickSearch = (e: any) => {
    setAnnoucementLists(null);
    setFilter((oldValues: any) => ({ ...oldValues, ['subject']: search }));
  };

  const handlePageClick = (event: any) => {
    setAnnoucementLists(null);
    const newOffset = (event.selected * filter.perpage) % pagination.totalCount;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`,
    );
    setOffset(newOffset);
    setFilter((oldValues: any) => ({ ...oldValues, ['offset']: newOffset }));
  };

  let helpModalClose = () => {
    setFormCreateModalShow(false);
    setTemplateError('');
  };

  function handleCreateAn(s: any) {
    setEditorInput((oldValues: any) => ({ ...oldValues, ['editorTh']: '' }));
    setEditorInput((oldValues: any) => ({ ...oldValues, ['editorEn']: '' }));
    setFormCreateModalShow(true);
  }

  useEffect(() => {
    Moment.locale('th');
    setLoader(true);
    //
    if (annoucementLists === null) {
      getBackendAnnouncementList(filter).then((response: any) => {
        const getData: any = response;
        setPagination({
          totalPage: getData.totalPages,
          currentPage: 1,
          totalCount: getData.totalCount,
        });
        setAnnoucementLists(getData.announcements);
        setLoader(false);
      });
    }
  }, [filter, annoucementLists, editorInput]);

  if (key === 'profile') {
    Moment.locale('en-sg');
  } else {
    Moment.locale('th');
  }

  return (
    <>
      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Anouncement</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-2">
                  <div className="row my-3 px-4 pt-3 filter-block">
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="d-flex">
                        <label className="mt-2">Show </label>
                        <select
                          className="form-select w-auto ms-2"
                          aria-label="Default select example"
                          name="perpage"
                          onChange={setInputValue}
                          defaultValue={10}
                        >
                          <option
                            value={10}
                            selected={filter.perpage === 10 ? true : false}
                          >
                            10
                          </option>
                          <option
                            value={20}
                            selected={filter.perpage === 20 ? true : false}
                          >
                            20
                          </option>
                          <option
                            value={30}
                            selected={filter.perpage === 30 ? true : false}
                          >
                            30
                          </option>
                          <option
                            value={40}
                            selected={filter.perpage === 40 ? true : false}
                          >
                            40
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-8 col-md-8">
                      <div className="d-flex justify-content-end">
                        <div className="d-flex">
                          <label className="mt-2 me-2">Search </label>
                          <InputGroup>
                            <Form.Control
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              placeholder="Enter subject"
                              name="subject"
                              onChange={setInputValue}
                              onKeyDown={onEnterSearch}
                            />
                            <Button
                              variant="outline-secondary btn-search-icon"
                              id="button-addon2"
                              onClick={onClickSearch}
                            >
                              <img
                                src="../../../images/backoffice/search.png"
                                width={20}
                              />
                            </Button>
                          </InputGroup>
                        </div>
                        <Button
                          className="btn-submit ms-3"
                          id="create_an"
                          onClick={handleCreateAn}
                        >
                          {' '}
                          Create
                        </Button>
                      </div>
                    </div>
                  </div>
                  <table className="table hr-table">
                    <thead>
                      <tr>
                        <th scope="col">Create date</th>
                        <th scope="col">Published Date</th>
                        <th scope="col">Title</th>
                        <th scope="col" className="text-center">
                          STATUS
                        </th>
                        <th scope="col" className="text-center">
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {annoucementLists ? (
                        annoucementLists.map((item: any, key: number) => (
                          <tr key={`tr-${key}`}>
                            <td>
                              {moment(item.createdDateTime + 'Z')
                                .tz('Asia/Bangkok')
                                .format('DD-MM-YYYY HH:mm')}
                            </td>
                            <td>
                              {moment(item.publishedDateTime + 'Z')
                                .tz('Asia/Bangkok')
                                .format('DD-MM-YYYY HH:mm')}
                            </td>
                            <td>{item?.subjectTh}</td>
                            <td className="text-center">
                              <Badge
                                status={item.statusStr}
                                text={item.statusStr}
                              />
                            </td>
                            <td className="text-center">
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/view.png"
                                onClick={() => selectAnnoucement(item)}
                                title="view"
                              />
                              <img
                                className="a-edit mx-4"
                                src="../../../images/backoffice/edit.png"
                                onClick={() => selectEditAnnoucement(item)}
                                title="edit"
                              />
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/trash.png"
                                onClick={() => selectDeleteAnnoucement(item)}
                                title="delete"
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="tr_loding">
                            {loder ? (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="&raquo;"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pagination.totalPage}
                    previousLabel="&laquo;"
                    className="pagination justify-content-end hr-pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="prevPage"
                    nextClassName="nextPage"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    activeLinkClassName="link-active"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        {...props}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Preview Anouncement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 request-detail">
          <Tabs
            defaultActiveKey="home"
            id="uncontrolled-tab-example"
            activeKey={key}
            onSelect={(k: any) => setKey(k)}
            className="mb-3 announcement-tab"
          >
            <Tab eventKey="home" title="ภาษาไทย">
              <div className="row ">
                <div className="col-12 mb-2">
                  <img
                    src={`data:image/jpg;base64,${annoucementItem?.thumnail}`}
                    className="mb-2 w-100 rounded img-thumbnail"
                  />
                </div>
                <div className="col-12">
                  <h4 className="emp-name mt-2">
                    {annoucementItem?.subjectTh}
                  </h4>
                  <p className="p-date">
                    <img
                      src="../../../images/backoffice/calendar.png"
                      width={15}
                    />{' '}
                    {Moment(annoucementItem?.publishedDateTime).format(
                      'DD MMM YYYY',
                    )}
                  </p>
                </div>
                <div className="col-12 col-sm-12 col-md-12 mb-3 pt-4">
                  <p className="mb-4">{annoucementItem?.shortDetailsTh}</p>
                  <p>{parse(annoucementItem?.detailsTh ?? '')}</p>
                </div>
              </div>
            </Tab>
            <Tab eventKey="profile" title="English">
              <div className="row ">
                <div className="col-12 mb-2">
                  <img
                    src={`data:image/jpg;base64,${annoucementItem?.thumnail}`}
                    className="mb-2 w-100 rounded img-thumbnail"
                  />
                </div>
                <div className="col-12">
                  <h4 className="emp-name mt-2">
                    {annoucementItem?.subjectEn}
                  </h4>
                  <p className="p-date">
                    <img
                      src="../../../images/backoffice/calendar.png"
                      width={20}
                    />{' '}
                    {Moment(annoucementItem?.publishedDateTime).format(
                      'DD MMM YYYY',
                    )}
                  </p>
                </div>
                <div className="col-12 col-sm-12 col-md-12 mb-3 pt-4">
                  <p className="mb-4">{annoucementItem?.shortDetailsEn}</p>
                  <p>{parse(annoucementItem?.detailsEn ?? '')}</p>
                </div>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={formModalShow}
        onHide={() => setFormModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Edit Anouncement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <Tabs
            defaultActiveKey="home"
            id="uncontrolled-tab-example"
            className="mb-3 announcement-tab"
          >
            <Tab eventKey="home" title="ภาษาไทย">
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">หัวข้อ</label>
                    <input
                      name="subjectTh"
                      type="text"
                      maxLength={255}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="หัวข้อ"
                      value={
                        annoucementItem?.subjectTh === 'null'
                          ? ''
                          : annoucementItem?.subjectTh
                      }
                      onChange={setEditInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">รายละเอียดแบบย่อ </label>
                    <textarea
                      name="shortDetailsTh"
                      maxLength={255}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="รายละเอียดแบบย่อ"
                      value={
                        annoucementItem?.shortDetailsTh === 'null'
                          ? ''
                          : annoucementItem?.shortDetailsTh
                      }
                      onChange={setEditInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">รายละเอียด </label>
                    <ReactQuill
                      value={editorInput.editorTh}
                      onChange={setCreateThEditorValue}
                      theme="snow"
                    />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="profile" title="English">
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Title</label>
                    <input
                      name="subjectEn"
                      type="text"
                      maxLength={255}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="Annoucement topic"
                      value={annoucementItem?.subjectEn}
                      onChange={setEditInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Short Description </label>
                    <textarea
                      name="shortDetailsEn"
                      maxLength={255}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="Exceprt"
                      value={
                        annoucementItem?.shortDetailsEn === 'null'
                          ? ''
                          : annoucementItem?.shortDetailsEn
                      }
                      onChange={setEditInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Description </label>
                    <ReactQuill
                      value={editorInput.editorEn}
                      onChange={setCreateEnEditorValue}
                      theme="snow"
                    />
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
          <div className="row">
            <div className="col-6 mb-4">
              <div className="form-group">
                <label className="mb-2">Publish Date</label>
                <input
                  type="datetime-local"
                  name="publishedDateTime"
                  value={annoucementItem?.publishedDateTime}
                  className="form-control"
                  id="start_date"
                  aria-describedby="Start Date"
                  placeholder=""
                  onChange={setEditInputValue}
                />
              </div>
            </div>
            <div className="col-6 mb-4 pt-1">
              <div>
                <p className="mb-2">Status</p>
                <Switch
                  onChange={() => handleEditSwitch()}
                  checked={annoucementItem?.status === 1 ? true : false}
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
              </div>
            </div>
            <div className="col-6 mb-2 pt-1">
              <img
                className="w-100 h-100 rounded"
                src={`data:image/jpg;base64,${annoucementItem?.thumnail}`}
                alt=""
              />
            </div>
            <div className="col-6 mb-2 ps-2 annoucement-upload annoucement-upload-edit">
              <FileUploader
                multiple={false}
                handleChange={handleEditChange}
                name="file"
                types={fileTypes}
                maxSize="2"
                className="fileuploader h-100"
              />
            </div>
            <Alert
              key="info"
              variant="info"
              className="message text-center mt-2 px-2"
            >
              *File dimenssion 600x400 pixel and maximun size 2 MB.{' '}
            </Alert>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onEditAnnounce()} className="btn-submit">
            Save
          </Button>
          <Button
            onClick={() => setFormModalShow(false)}
            className="btn-cancel"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={formCreateModalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Create Anouncement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          {templateError !== '' ? (
            <Alert
              key="danger"
              variant="danger"
              className="message p-2 text-center"
            >
              กรุณาป้อนรูปภาพของ Anouncement
            </Alert>
          ) : (
            <></>
          )}
          <Tabs
            defaultActiveKey="CreateTH"
            id="uncontrolled-tab-example"
            className="mb-3 announcement-tab"
          >
            <Tab eventKey="CreateTH" title="ภาษาไทย">
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">หัวข้อ </label>
                    <input
                      name="subjectTh"
                      maxLength={255}
                      type="text"
                      className="form-control"
                      aria-describedby="name"
                      placeholder="หัวข้อ"
                      value={announcementInputForm?.subjectTh}
                      onChange={setCreateInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">รายละเอียดแบบย่อ </label>
                    <textarea
                      name="shortDetailsTh"
                      maxLength={255}
                      value={announcementInputForm?.shortDetailsTh}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="รายละเอียดแบบย่อ"
                      onChange={setCreateInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">รายละเอียด </label>
                    <ReactQuill
                      value={editorInput.editorTh}
                      onChange={setCreateThEditorValue}
                      theme="snow"
                    />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="CreateEN" title="English">
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Titile </label>
                    <input
                      name="subjectEn"
                      maxLength={255}
                      type="text"
                      className="form-control"
                      aria-describedby="name"
                      placeholder="Title"
                      value={announcementInputForm?.subjectEn}
                      onChange={setCreateInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Short Description</label>
                    <textarea
                      name="shortDetailsEn"
                      maxLength={255}
                      value={announcementInputForm?.shortDetailsEn}
                      className="form-control"
                      aria-describedby="name"
                      placeholder="Short Description"
                      onChange={setCreateInputValue}
                    />
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="mt-2 me-2">Description </label>
                    <ReactQuill
                      value={editorInput.editorEn}
                      onChange={setCreateEnEditorValue}
                      theme="snow"
                    />
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
          <div className="row">
            <div className="col-6 mb-4">
              <div className="form-group">
                <label className="mb-2">Publish Date</label>
                <input
                  type="datetime-local"
                  name="publishedDateTime"
                  value={announcementInputForm?.publishedDateTime}
                  className="form-control"
                  id="start_date"
                  aria-describedby="Start Date"
                  placeholder=""
                  onChange={setCreateInputValue}
                />
              </div>
            </div>
            <div className="col-6 mb-4 pt-1">
              <div>
                <p className="mb-2">Status</p>
                <Switch
                  onChange={() => handleSwitch()}
                  checked={checked}
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
              </div>
            </div>
            <div className="col-12 mb-2 annoucement-upload">
              <FileUploader
                multiple={false}
                handleChange={handleChange}
                name="file"
                maxSize="2"
                types={fileTypes}
                className="fileuploader"
              />
              <Alert
                key="info"
                variant="info"
                className="message text-center mt-2 px-2"
              >
                *ขนาดภาพ 600x400 pixel และ ขนาดไฟล์ไม่เกิน 2 mb{' '}
              </Alert>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onCreateAnnounce()} className="btn-submit">
            Save
          </Button>
          <Button
            onClick={() => onCancelCreacteAnnounce()}
            className="btn-cancel"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Confirm delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 text-center">
          <p>Please confirm delete this announcement</p>
          <p>"{annoucementItem?.subjectTh}"</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onDelete()} className=" btn-danger">
            Confirm
          </Button>
          <Button
            onClick={() => setDeleteModalShow(false)}
            className="btn-cancel"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {pageLoder ? (
        <div className="pageLoder">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <ToastContainer />
    </>
  );
};
